<template>
  <div class="login-layout">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "LoginLayout",
  mounted() {
    document.body.setAttribute("id", "kt_body");
    document.body.className = "app-blank";
  },
  beforeUnmount() {
    document.body.removeAttribute("id");
    document.body.className = "";
  },
};
</script>

<style scoped>
.login-layout {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f0f2f5;
}
</style>
